import {createTheme, responsiveFontSizes} from "@mui/material";
import {THEME_CONFIG} from "../config";

const {gradients, primary, secondary, accent, background, mode, text} = THEME_CONFIG

const pleshDark = responsiveFontSizes(createTheme({
    typography: {
      fontFamily: ['AvenirNextWorld']
    },
    components:{
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background: background,
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "fixed",
                },
            },
        },
        MuiDialog:{
            styleOverrides:{
                paper:{
                    background: background,
                }
            }
        },
        MuiTextField:{
            styleOverrides:{
                root:{
                    '& fieldset':{
                        borderWidth:'3px !important',
                        borderRadius:'1rem'
                    }
                }
            }
        },
        MuiButton:{
            variants: [
                //siNo
                {
                    props: {variant:'siNo'},
                    style:{
                        width: '100%',
                        height: '100%',
                        borderRadius: 10,
                        border: 0,
                        color: "white !important",
                    },
                },
                {
                    props: {variant:'siNo', risposta: 'si'},
                    style:{
                        background: gradients.siNo[0],
                    },
                },
                {
                    props: {variant:'siNo', risposta: 'no'},
                    style:{
                        background: gradients.siNo[1],
                    },
                },
                //sentiment
                {
                    props: {variant:'sentiment'},
                    style:{
                        width: '100%',
                        height: '100%',
                        borderRadius: 10,
                        border: 0,
                        color: "white !important",
                    },
                },
                {
                    props: {variant:'sentiment', risposta: 'daccordo'},
                    style:{
                        background: gradients.sentiment[0],
                    },
                },
                {
                    props: {variant:'sentiment', risposta: 'nonDaccordo'},
                    style:{
                        background: gradients.sentiment[1],
                    },
                },
                {
                    props: {variant: 'default'},
                    style:{
                        background: 'linear-gradient(90deg, '+gradients.home_question[0]+' 0%, '+gradients.home_question[1]+')',
                        border:'1px solid '+'rgba(236,239,241,0.45)',
                        fontWeight: 'bold',
                        borderRadius: '8px',width: '100%', height: '50px',
                        boxShadow: '0 0 10px 2px '+'rgba(255,0,128,0.8)',
                    }
                },
                {
                    props: {variant: 'clap'},
                    style:{
                        height: '100px',
                        width:'80%',
                        fontSize: '18px',
                        background: 'linear-gradient(90deg, '+gradients.applausometro[0]+' 0%, '+gradients.applausometro[1]+')',
                        border:'none',
                        color: '#f1ebe9',
                        borderRadius: '8px',
                        borderWidth: '3px',
                    }
                },
                {
                    props: {variant: 'home-question'},
                    style:{
                        background: 'linear-gradient(90deg, '+gradients.home_question[0]+' 0%, '+gradients.home_question[1]+')',
                        border:'1px solid '+'rgba(236,239,241,0.45)',
                        fontWeight: 'bold',
                        borderRadius: '8px',width: '100%', height: '50px',
                        boxShadow: '0 0 10px 2px '+'rgba(255,0,128,0.8)',
                    }
                },
                {
                    props: {variant: 'qna'},
                    style:{
                        background: 'linear-gradient(90deg, '+gradients.qna[0]+' 0%, '+gradients.qna[1]+')',
                        fontSize: '18px',
                        border:'none',
                        fontWeight:'bold',
                        color: '#000',
                        borderRadius: '8px',width: '100%', height: '50px'
                    }
                }
            ]
        },
    },
    palette: {
        mode: mode,
        primary: {
            main: primary,
        },
        secondary: {
            main: secondary,
        },
        accent: {
            main: accent,
        },
        text: {
            primary: text,
        },
        background:{
            default:background
        }
    },
}));

export default pleshDark
